/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FatturaEmessaDtoFromJSON, FatturaEmessaDtoToJSON, } from './FatturaEmessaDto';
/**
 * Check if a given object implements the FatturaEmessaPagedDto interface.
 */
export function instanceOfFatturaEmessaPagedDto(value) {
    return true;
}
export function FatturaEmessaPagedDtoFromJSON(json) {
    return FatturaEmessaPagedDtoFromJSONTyped(json, false);
}
export function FatturaEmessaPagedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'] == null ? undefined : (json['content'].map(FatturaEmessaDtoFromJSON)),
        'size': json['size'] == null ? undefined : json['size'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}
export function FatturaEmessaPagedDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'] == null ? undefined : (value['content'].map(FatturaEmessaDtoToJSON)),
        'size': value['size'],
        'page': value['page'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}
